import { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { BoardContext, UserContext } from "../../../context";
import { getUrlTokenExtracted } from "../../../context/helpers";
import { MainButton } from "../../atoms";
import closeIcon from "../../../assets/icons/deleteStrengthCard.svg";
import { useSound } from "../../../hooks";

const SendEmailToUser = () => {
    const { sendMessageToTheUser, setSendMessageToTheUser } = useContext(BoardContext);
    const { notificationSendEmail } = useContext(UserContext);
    const { t } = useTranslation();
    const {playSound} = useSound();
    const [value, setValue] = useState<string>("");
    const updatedQuestionValue = useRef<string>("");

    const onChange = (e: any) => {
        setValue(e.target.value);
    }

    const close = () => {
        playSound("/sounds/LightClick.mp3");
        setSendMessageToTheUser({ 
            selectedUserEmail: "", 
            isMessageBoxOpen: false 
        })
    }

    const sendTheMessage = () => {
        const adminEmail: string = sendMessageToTheUser.selectedUserEmail;
        const matchId: string = getUrlTokenExtracted();
        const message: string = updatedQuestionValue.current;
        console.log({ adminEmail, matchId, message });
        notificationSendEmail(adminEmail, matchId, message);
        setSendMessageToTheUser({ 
            selectedUserEmail: "", 
            isMessageBoxOpen: false 
        })
    }

    return (
        <div className="send_email_to_user_wrapper">
            <div className="send_email_wrapper">
                <img className="close_button" src={closeIcon} onClick={close} alt="icon x" />
                <div className="send_email_to_user">
                    <textarea
                        value={value}
                        onChange={(event) => onChange(event)}
                        placeholder={t("typeAmessageYouWantToSentToTheUserText")}
                        cols={40}
                        rows={5} 
                        onBlur={() => updatedQuestionValue.current = value }  
                    />
                    <div className="button_holder">    
                        <MainButton smallText={true} type="small" text={t("sendAnEmailText")} clickHandler={() => sendTheMessage()} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SendEmailToUser;

function ComponentsContext(ComponentsContext: any): { popUpBoxType: any; } {
    throw new Error("Function not implemented.");
}
